import React, { useContext } from "react"

import { Header, HeaderYeni } from "./Header"

// Global styles and component-specific styles.
import "./global.css"
import { main } from "./main.module.css"
import GenericBreadcrumbs from "./Breadcrumb/GenericBreadcrumb"
import Footer from "./Footer/Footer"
import { Box, useMediaQuery,useTheme } from "@mui/material"




export default function Layout ({ children }) { 
  const theme = useTheme();

  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  
  
  
  return (
  <Box sx={{justifyContent:'center',alignItems:'center'}}>
    <Header />
    {/*<GenericBreadcrumbs />*/}
    {/*<main className={main}>{children}</main>*/}
    <Box mx={'auto'} maxWidth={'lg'} sx={{paddingLeft: isLgDown ? 1 : 0,paddingRight: isLgDown ? 1 : 0}} >{children}</Box>
    <Footer />
  </Box>
)
}


export function LayoutSSR ({ children }) { 
  const theme = useTheme();

  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

  
  
  
  return (
  <Box sx={{justifyContent:'center',alignItems:'center'}}>
    <Header />
    {/*<GenericBreadcrumbs />*/}
    {/*<main className={main}>{children}</main>*/}
    {children}
    <Footer />
  </Box>
)
}

